export default "{\n    \"overdue\": \"En retard\",\n    \"expiresIn\": \"Expire dans\"\n}\n"